import { render, staticRenderFns } from "./VehicleActionForm.vue?vue&type=template&id=0d31f9f5&"
import script from "./VehicleActionForm.vue?vue&type=script&lang=ts&"
export * from "./VehicleActionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports